import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';

interface RegistrationPageProps {
  onBack: () => void;
  onNavigateToLogin: () => void;
}

const RegistrationPage: React.FC<RegistrationPageProps> = ({ onBack, onNavigateToLogin }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleInputChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const handleRegistration = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Basic validation
    if (formData.password !== formData.confirmPassword) {
      setError('A jelszavak nem egyeznek meg');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('A jelszónak legalább 6 karakter hosszúnak kell lennie');
      setLoading(false);
      return;
    }

    try {
      // TODO: Implement actual registration logic with backend API
      await new Promise(resolve => setTimeout(resolve, 2000)); // Simulate API call
      console.log('Registration attempt:', formData);
      setSuccess('Sikeres regisztráció! Most már bejelentkezhetsz.');
    } catch (err) {
      setError('Hiba történt a regisztráció során');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        backgroundColor: '#f0f3f6',
        padding: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Card sx={{ backgroundColor: 'white', maxWidth: 400, width: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Regisztráció
          </Typography>
          
          <Box component="form" onSubmit={handleRegistration} sx={{ mt: 3 }}>
            <TextField
              fullWidth
              label="Teljes név"
              value={formData.name}
              onChange={handleInputChange('name')}
              required
              margin="normal"
              variant="outlined"
            />
            
            <TextField
              fullWidth
              label="Email cím"
              type="email"
              value={formData.email}
              onChange={handleInputChange('email')}
              required
              margin="normal"
              variant="outlined"
            />
            
            <TextField
              fullWidth
              label="Jelszó"
              type="password"
              value={formData.password}
              onChange={handleInputChange('password')}
              required
              margin="normal"
              variant="outlined"
            />
            
            <TextField
              fullWidth
              label="Jelszó megerősítése"
              type="password"
              value={formData.confirmPassword}
              onChange={handleInputChange('confirmPassword')}
              required
              margin="normal"
              variant="outlined"
            />
            
            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}
            
            {success && (
              <Alert severity="success" sx={{ mt: 2 }}>
                {success}
              </Alert>
            )}
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{ 
                mt: 3, 
                mb: 2,
                backgroundColor: '#3a4651',
                '&:hover': {
                  backgroundColor: '#2d3640',
                }
              }}
            >
              {loading ? <CircularProgress size={24} /> : 'Regisztráció'}
            </Button>
            
            <Button
              fullWidth
              variant="text"
              onClick={onNavigateToLogin}
              sx={{ color: '#3a4651' }}
            >
              Már van fiókod? Jelentkezz be itt
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default RegistrationPage;
